import React, {useEffect, useState} from "react";

// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";

import {fieldCheckSearchListCloseAction} from "../../features/sliceReducer/interactionReducer";

//import component
import SearchForm from "../../components/SearchForm";

//import material-UI
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import Loading from "../../components/Loading";
import {
  addCopiedCount,
  fieldCheckReferenceList,
} from "../../features/sliceReducer/myProjectReducer";
import useCopyClipBoard from "../../customHook/useCopyClipBoard";
import IPUtility from "../../classes/IPUtility";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1480px",
      minWidth: "1480px",
      height: "880px",
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    table: {
      // minWidth: 650,
      border: "1px solid #dbdce0",
    },
    buttonCell: {
      display: "flex",
      width: "100%",
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: " 20px",
      "& form": {
        marginRight: "36px",
      },
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },

    buttonMargin: {
      // flex: "0 0 auto",
      // width: "80px",
      // height: "36px",
      marginRight: "5px",
    },
  })
);

const FieldCheckSearchModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchWord, setSearchWord] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const {fieldCheckSearchListModalToggle} = useSelector((state: RootState) => state.interaction);

  const {
    searchFieldChecks: searchFieldChecks,
    loading,
    error,
    selectItem,
    quotationListTableHeader,
  } = useSelector((state: RootState) => state.myProject);

  const {userToken} = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(fieldCheckReferenceList({userToken, searchWord}));
  }, [selectItem, searchWord]);

  const searchDispatcher = (page?: number, keyword?: string) => {
    if (page === undefined) page = 1;
    if (keyword === undefined) dispatch(fieldCheckReferenceList({userToken, searchWord}));
    else
      dispatch(
        fieldCheckReferenceList({
          userToken,
          searchWord: keyword,
          // id: selectItem,
        })
      );
  };

  const [isCopy, onCopy] = useCopyClipBoard();
  const handleCopyClipBoard = (text: string) => {
    onCopy(text);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={fieldCheckSearchListModalToggle}
      onClose={() => {
        dispatch(fieldCheckSearchListCloseAction());
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={fieldCheckSearchListModalToggle}>
        <TableContainer component={Paper} className={classes.paper}>
          {fieldCheckSearchListModalToggle || <Loading loading={loading} />}
          <Typography className={classes.modalTitle} variant="h5" component="h5">
            많이 인용된 아이템
          </Typography>
          <Box className={classes.searchInput}>
            <SearchForm
              setSearchWord={setSearchWord}
              page={page}
              searchDispatcher={searchDispatcher}
              searchWord={searchWord}
            />
          </Box>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell key="refProcessName" align="center">
                  공정명
                </TableCell>
                <TableCell key="refItemName" align="center">
                  항목명
                </TableCell>
                <TableCell key="refLocation" align="center" width="8%">
                  위치(설비명)
                </TableCell>
                <TableCell key="refNotice" align="center">
                  지적사항
                </TableCell>
                <TableCell key="refImprove" align="center">
                  개선대책
                </TableCell>
                <TableCell key="refRegulation" align="center">
                  관련법규
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {searchFieldChecks &&
                searchFieldChecks.length > 0 &&
                searchFieldChecks?.map((fieldCheck, index) => {
                  return (
                    <StyledTableRow key={fieldCheck.uid}>
                      <TableCell key={fieldCheck.uid + "refProcessName"} align="center">
                        {fieldCheck.processName}
                      </TableCell>
                      <TableCell key={fieldCheck.uid + "refItemName"} align="center">
                        {fieldCheck.itemName}
                      </TableCell>
                      <TableCell key={fieldCheck.uid + "refLocation"} align="center">
                        {fieldCheck.specName}
                      </TableCell>
                      <TableCell key={fieldCheck.uid + "refNotice"} style={{verticalAlign: "top"}}>
                        <Button
                          className={classes.buttonMargin}
                          onClick={() => {
                            // IPUtility.copyString(fieldCheck.notice);
                            handleCopyClipBoard(fieldCheck.notice);
                          }}
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<FileCopyIcon />}
                        />
                        {fieldCheck.notice}
                      </TableCell>
                      <TableCell key={fieldCheck.uid + "refImprove"} style={{verticalAlign: "top"}}>
                        <Button
                          className={classes.buttonMargin}
                          onClick={() => {
                            // IPUtility.copyString(fieldCheck.improve);
                            handleCopyClipBoard(fieldCheck.improve);
                          }}
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<FileCopyIcon />}
                        />
                        {fieldCheck.improve}
                      </TableCell>
                      <TableCell
                        key={fieldCheck.uid + "refRegulation"}
                        style={{verticalAlign: "top"}}
                      >
                        <Button
                          className={classes.buttonMargin}
                          onClick={() => {
                            //IPUtility.copyString(fieldCheck.regulation);
                            handleCopyClipBoard(fieldCheck.regulation);
                          }}
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<FileCopyIcon />}
                        />
                        {fieldCheck.regulation}
                      </TableCell>
                    </StyledTableRow>
                  );

                  // const typeLines = [] as string[];
                  // const contentLines = [] as string[];
                  // const quotationCount = [] as number[];
                  // if (
                  //   fieldCheck.notice !== undefined &&
                  //   fieldCheck.notice.length > 0
                  // ) {
                  //   contentLines.push(fieldCheck.notice);
                  //   // quotationCount.push(fieldCheck.generalCopiedCount);
                  //   typeLines.push("지적사항");
                  // }
                  // if (
                  //   fieldCheck.regulation !== undefined &&
                  //   fieldCheck.regulation.length > 0
                  // ) {
                  //   contentLines.push(fieldCheck.regulation);
                  //   // quotationCount.push(fieldCheck.regulationCopiedCount);
                  //   typeLines.push("관련법규");
                  // }
                  // if (
                  //   fieldCheck.improve !== undefined &&
                  //   fieldCheck.improve.length > 0
                  // ) {
                  //   contentLines.push(fieldCheck.improve);
                  //   // quotationCount.push(fieldCheck.recommendationCopiedCount);
                  //   typeLines.push("개선사항");
                  // }

                  // return typeLines.map((x, index2) => (
                  //   <StyledTableRow key={fieldCheck.uid + "-" + index2}>
                  //     <TableCell width="10%" align="center">
                  //       {typeLines[index2]}
                  //     </TableCell>
                  //     <TableCell width="80%" className={classes.buttonCell}>
                  //       <Button
                  //         className={classes.buttonMargin}
                  //         onClick={() => {
                  //           IPUtility.copyString(contentLines[index2]);
                  //           // handleCopyClipBoard(contentLines[index2]);
                  //           // dispatch(
                  //           //   addCopiedCount({ userToken, id: itemValue.uid, type })
                  //           // );
                  //         }}
                  //         size="small"
                  //         variant="contained"
                  //         color="primary"
                  //         startIcon={<FileCopyIcon />}
                  //       >
                  //       </Button>
                  //       <p>{contentLines[index2]}</p>
                  //     </TableCell>
                  //     <TableCell width="10%" align="center">
                  //       {/* {quotationCount[index2]} */}
                  //     </TableCell>
                  //   </StyledTableRow>
                  // ));
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Fade>
    </Modal>
  );
};

export default FieldCheckSearchModal;
